export default __webpack_public_path__ + "4e89e21959a867842b0cd7f89663b400.png";